// Placeholder'ları değiştiren genel fonksiyon

  export function replacePlaceholders(text, values) {
    return text.replace(/\{(\w+)\}/g, (_, key) => 
      values[key] !== undefined && values[key] !== null ? values[key] : ''
    );
  }
  